import { render, staticRenderFns } from "./PreviewTabSwitch.vue?vue&type=template&id=53c9af0c&scoped=true&"
import script from "./PreviewTabSwitch.vue?vue&type=script&lang=js&"
export * from "./PreviewTabSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9af0c",
  null
  
)

export default component.exports